import React from "react";
import { Link } from "react-router-dom";
import { BreadcrumbChevronIcon, BreadcrumbHomeIcon } from "./BreadcrumbIcons";

interface BreadcrumbItem {
  title: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  /** Extra classes on the outer nav wrapper (e.g. `breadcrumb-wrapper--on-dark`). */
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className }) => {
  return (
    <nav aria-label="Breadcrumb" className={`breadcrumb-wrapper${className ? ` ${className}` : ''}`}>
      <ol className="breadcrumb">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isHome = item.title.toLowerCase() === "home";
          const itemPath = isHome ? "/overview" : item.path;

          return (
            <li
              key={`${index}-${item.title}`}
              className={`breadcrumb-item ${isLast ? "active" : ""}`}
              {...(isLast ? { "aria-current": "page" } : {})}
            >
              {!isLast && itemPath ? (
                isHome ? (
                  <Link to={itemPath} className="breadcrumb-home-link">
                    <BreadcrumbHomeIcon />
                    <span className="visually-hidden">Home</span>
                  </Link>
                ) : (
                  <Link to={itemPath}>{item.title}</Link>
                )
              ) : (
                <span className="breadcrumb-item__label">{item.title}</span>
              )}

              {!isLast && (
                <span className="separator" aria-hidden="true">
                  <BreadcrumbChevronIcon />
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
